import { Directive, AfterViewInit, OnDestroy, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import * as _ from 'lodash';
import { debounceTime, fromEvent, Subscription } from 'rxjs';

@Directive({
  selector: 'input[matAutocomplete]' // applies to all mat-autocomplete inputs
})
export class CloseAutocompleteOnScrollDirective implements AfterViewInit, OnDestroy {
  private static triggers: MatAutocompleteTrigger[] = [];
  private scrollSub: Subscription;
  private openedSub: Subscription;

  constructor(private trigger: MatAutocompleteTrigger, @Optional() private ngControl: NgControl) {}

  ngAfterViewInit() {
    CloseAutocompleteOnScrollDirective.triggers.push(this.trigger);

    this.openedSub = (this.trigger.autocomplete as MatAutocomplete).opened.subscribe(() => {
        CloseAutocompleteOnScrollDirective.triggers.forEach(otherTrigger => {
          if (otherTrigger !== this.trigger) {
            otherTrigger.closePanel();
          }
        });
    });

    // Listen to scroll events on document with capture to catch all scrollable elements
    this.scrollSub = fromEvent(document, 'scroll', { capture: true })
      .subscribe((event: Event) => {
        if (this.trigger.panelOpen) {
          const target = event.target as Element;
          // Don't close if scrolling within the autocomplete panel
          if (!target.closest('.mat-autocomplete-panel')) {
            this.trigger.closePanel();
            const element = (this.trigger as any)._element.nativeElement;
            element.addEventListener('blur', (e) => e.stopImmediatePropagation(), { once: true });
            element.blur();
            element.value = '';
            if (this.ngControl?.control) {
              const currentValue = this.ngControl.control.value;
              if (!_.isArray(currentValue) && !_.isObject(currentValue)) {
                this.ngControl.control.patchValue('', { emitEvent: true });
              }
            }
          }
        }
    });
  }

  ngOnDestroy() {
    this.scrollSub?.unsubscribe();
    this.openedSub?.unsubscribe();
    
    // Remove this trigger from static array
    const index = CloseAutocompleteOnScrollDirective.triggers.indexOf(this.trigger);
    if (index > -1) {
      CloseAutocompleteOnScrollDirective.triggers.splice(index, 1);
    }
  }
}
